export var getChartColor = function (color) {
    switch (color) {
        case 'Blue':
            return '#007DBA';
        case 'Navy':
            return '#004478';
        case 'Green':
            return '#2C6B64';
        case 'Red':
            return '#E3173E';
        default:
            return 'darkGray';
    }
};
export var DonutChartMaxSections = 4;
export default getChartColor;
